// extracted by mini-css-extract-plugin
export default {"Sort":"Sort_Sort__2jJhA","label":"Sort_label__mx3aH"};